import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import docCookies from '../../common/cookie';
import { API_URL, LIVE } from '../../common/variables';

const initialAppState = {
  lang: 'en',
  isFetchingUser: false,
  errorLogin: false,
  isLogin: false,
  forgottenError: null,
  isRequestingForgottenPass: false,
  isConfirmingForgottenPass: false,
  confirmingForgottenError: null,
}

const forgottenPasswordRequest = createAsyncThunk(
  'ON_FORGOTTEN_PASSWORD',
  async ({ email }, { rejectWithValue }) => {
    try {
      let res = await fetch(API_URL + '/users/password_recovery_by_email', {
        body: JSON.stringify({ live: LIVE, email: email }),
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      if (res.status === 200) {
        return { isRequestingForgottenPass: false, forgottenError: false };
      } else
        return rejectWithValue({
          isRequestingForgottenPass: false,
          forgottenError: res.status,
        });
    } catch (err) {
      // console.log(err);
      return rejectWithValue({
        isRequestingForgottenPass: false,
        forgottenError: 900,
      });
    }
  },
);

const confirmForgottenPasswordRequest = createAsyncThunk(
  'ON_CONFIRM_FORGOTTEN_PASSWORD',
  async ({ email, code, password }, { rejectWithValue }) => {
    try {
      let res = await fetch(
        API_URL + '/users/confirm_password_recovery_by_email',
        {
          body: JSON.stringify({
            live: LIVE,
            email: email,
            securityCode: code,
            password: password,
          }),
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      );
      if (res.status === 200) {
        return {
          isConfirmingForgottenPass: false,
          confirmingForgottenError: false,
        };
      } else
        return rejectWithValue({
          isConfirmingForgottenPass: false,
          confirmingForgottenError: res.status,
        });
    } catch (err) {
      // console.log(err);
      return rejectWithValue({
        isConfirmingForgottenPass: false,
        confirmingForgottenError: 900,
      });
    }
  },
);

const requestUserInfo = createAsyncThunk(
  'ON_REQUEST_USER_INFO',
  async (token) => {
    try {
      let res = await fetch(API_URL + '/users/info', {
        body: JSON.stringify({ live: LIVE }),
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        let info = await res.json();
        return { isFetching: false, user: info, token: token, error: false };
      } else throw new Error(res.status.toString());
    } catch (err) {
      throw new Error(err);
    }
  },
);

const onLogin = createAsyncThunk(
  'ON_LOGGING',
  async (arg, { rejectWithValue }) => {
    try {
      const { email, password } = arg;
      let res = await fetch(API_URL + '/token', {
        body: `username=${email}&password=${password}&live=${LIVE}`,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (res.status === 200) {
        let resToken = await res.json();
        return { user: {}, access_token: resToken.access_token };

        /* let inf = await fetch(API_URL + '/users/info', {
          method: 'POST',
          body: JSON.stringify({ live: LIVE }),
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${resToken.access_token}`,
          },
        }); */

        /* if (inf.status === 200) {
          let userInfo = await inf.json();
          return { user: userInfo, access_token: resToken.access_token };
        } else {
          return rejectWithValue({ error: true, errorCode: inf.status });
        } */
      }

      return rejectWithValue({ error: true, errorCode: res.status });
    } catch (err) {
      return rejectWithValue({ error: true, errorCode: 900 });
    }
  },
);
const appSlice = createSlice({
  name: 'app',
  initialState: initialAppState,
  reducers: {
    onLogOut(state) {
      localStorage.clear();
      sessionStorage.removeItem('isLogin');
      sessionStorage.removeItem('sessionToken');
      sessionStorage.clear();
      docCookies.removeItem('token');
      Cookies.remove('token');
      state.lang = 'en';
      state.isFetchingUser = false;
      state.errorLogin = false;
      state.isLogin = false;
    },
    onChangeLanguage(state, action) {
      state.lang = action.payload;
    },
  },
  extraReducers: {
    [requestUserInfo.fulfilled]: (state, action) => {
      sessionStorage.clear();
      // localStorage.clear();
      sessionStorage.setItem('sessionToken', action.payload.token);
      sessionStorage.setItem('isLogin', 'true');
      state = {
        ...state,
        isFetching: false,
        isLogin: true,
        user: action.payload.user,
        token: action.payload.token,
        error: false,
      };
      return state;
    },
    [requestUserInfo.pending]: (state) => {
      // state.isLogin = false;
      state.error = false;
    },
    [requestUserInfo.rejected]: (state) => {
      state.error = true;
      state.isLogin = false;
    },
    [onLogin.pending]: (state) => {
      state.isFetchingUser = true;
      state.errorLogin = false;
      state.isLogin = false;
    },
    [onLogin.fulfilled]: (state, action) => {
      state.isFetchingUser = true;
      state.errorLogin = false;
      state.isLogin = true;
      sessionStorage.clear();
      localStorage.clear();
      sessionStorage.setItem('sessionToken', action.payload.access_token);
      docCookies.setItem('token', action.payload.access_token, '86400');
      state.user = action.payload.user;
      state.token = action.payload.access_token;
    },
    [onLogin.rejected]: (state, action) => {
      state.isFetchingUser = false;
      state.errorLogin = action.payload;
      state.isLogin = false;
    },
    [forgottenPasswordRequest.pending]: (state, action) => {
      state.isRequestingForgottenPass = true;
      state.forgottenError = null;
    },
    [forgottenPasswordRequest.fulfilled]: (state, action) => {
      state.isRequestingForgottenPass = false;
      state.forgottenError = null;
    },
    [forgottenPasswordRequest.rejected]: (state, action) => {
      state.isRequestingForgottenPass = false;
      state.forgottenError = action.payload;
    },
    [confirmForgottenPasswordRequest.pending]: (state, action) => {
      state.isConfirmingForgottenPass = true;
      state.confirmingForgottenError = null;
    },
    [confirmForgottenPasswordRequest.fulfilled]: (state, action) => {
      state.isConfirmingForgottenPass = false;
      state.confirmingForgottenError = null;
    },
    [confirmForgottenPasswordRequest.rejected]: (state, action) => {
      state.isConfirmingForgottenPass = false;
      state.confirmingForgottenError = action.payload;
    },
  },
});

export const { onLogOut, onChangeLanguage } = appSlice.actions;

export {
  requestUserInfo,
  onLogin,
  forgottenPasswordRequest,
  confirmForgottenPasswordRequest,
};

export default appSlice.reducer;
